import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../api";
import { getToken } from "../models/users.models";
import {
  IAiPromptsWithMeta,
  IUpdatePromptRequest,
} from "../models/aiPrompts.models";

const aiPromptsConfig = {
  ...baseQueryConfig,
  baseUrl: baseQueryConfig.baseUrl + "/ai-prompts",
  prepareHeaders: (headers: Headers) => {
    const session = getToken();
    if (session && session.token) {
      headers.set("Authorization", `Bearer ${session.token}`);
    }
    return headers;
  },
};

export const aiPromptsApi = createApi({
  reducerPath: "prompts",
  tagTypes: ["Prompts"],
  baseQuery: fetchBaseQuery(aiPromptsConfig),
  endpoints: (builder) => ({
    getPrompts: builder.query<
      IAiPromptsWithMeta,
      { page: number; limit: number }
    >({
      query: ({ page, limit }) => ({
        url: "",
        params: { page, limit },
      }),
      providesTags: ["Prompts"],
    }),
    updatePrompt: builder.mutation<void, IUpdatePromptRequest>({
      query: ({ uid, ...data }) => ({
        url: `/${uid}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Prompts"],
    }),
  }),
});

export const { useGetPromptsQuery, useUpdatePromptMutation } = aiPromptsApi;
